import React from "react";

export default function PrivacyPolicy() {
  return (
    <main style={{ maxWidth: "800px", margin: "2em auto", padding: "1em" }}>
      <h1>プライバシーポリシー</h1>
      <p>最終更新日：2025年8月12日</p>

      <h2>1. 取得する情報</h2>
      <p>当社は、本サービスを通じて以下の情報を取得します。</p>
      <ul>
        <li>ユーザー認証情報 (OAuthトークン等)</li>
        <li>広告キャンペーン情報</li>
        <li>ログ情報</li>
        <li>アカウント情報</li>
      </ul>

      <h2>2. 利用目的</h2>
      <p>
        取得情報はサービス提供・維持・改善のために利用します。ユーザーのスケジュール設定に基づく広告操作の実行などが含まれます。
      </p>

      <h2>3. 保存期間</h2>
      <p>
        利用期間中保持し、退会時は削除します（法令等により保存が必要な場合を除く）。
      </p>

      <h2>4. 第三者提供</h2>
      <p>
        同意なく第三者に提供しません。法令順守やサービス運用上必要な場合のみ提供することがあります。
      </p>

      <h2>5. セキュリティ対策</h2>
      <p>トークン暗号化・アクセス制御・TLS通信を実施します。</p>

      <h2>6. ユーザーの権利</h2>
      <p>
        開示・訂正・削除等の請求ができます。下記までお問い合わせください。
      </p>

      <h2>7. お問い合わせ</h2>
      <p>
        運営者: TMS株式会社
        <br />
        Eメール: adsche@tms-ec.co.jp
      </p>
    </main>
  );
}